import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "full-view"
}

import BackgroundGradiant from '@shared/components/UIElements/BackgroundGradiant.vue';
import { redirectIfConnected } from '@/utils/redirect';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Spinner from '@shared/components/UIElements/Spinner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loading = ref(true);
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  await router.isReady();

  // These pages read the session themselves instead of leaving for the application.
  if (route.meta.handlesSession) {
    loading.value = false;
  } else {
    // Show the page unless the browser is leaving; an unverified session stays to verify.
    redirectIfConnected()
      .then((leaving) => {
        loading.value = leaving;
      })
      .catch(() => {
        // User is not connected, do nothing
        loading.value = false;
      });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                class: "full-view"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(BackgroundGradiant),
                _createVNode(_component_router_view)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})